function generateId() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
}

function createSelectOptions(arr, textKey, valueKey) {
    if (!Array.isArray(arr) || !textKey || !valueKey) {
        console.error('There is an error on Select input options');
        return [{ text: 'ERROR', value: null }];
    } else {
        let result = [];

        arr.forEach((item) => {
            result.push({ text: item[textKey], value: item[valueKey] });
        });

        return result;
    }
}

function isFunction(value) {
    return typeof value === 'function';
}

export { generateId, createSelectOptions, isFunction };
